// Picks a dark primary + contrasting accent colour from a logo image (client-side canvas).
const hex = (r, g, b) => `#${[r, g, b].map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0")).join("")}`;
const lum = ([r, g, b]) => 0.299 * r + 0.587 * g + 0.114 * b;
const dist = (a, b) => Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]);

export const logoColors = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = () => {
    try {
      const c = document.createElement("canvas");
      c.width = 80; c.height = 80;
      const ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0, 80, 80);
      const px = ctx.getImageData(0, 0, 80, 80).data;
      const buckets = {};
      for (let i = 0; i < px.length; i += 4) {
        const [r, g, b, a] = [px[i], px[i + 1], px[i + 2], px[i + 3]];
        if (a < 128) continue;
        const L = lum([r, g, b]);
        if (L > 235 || L < 12 || Math.max(r, g, b) - Math.min(r, g, b) < 28) continue;
        const k = `${r >> 4},${g >> 4},${b >> 4}`;
        const bk = (buckets[k] ||= { n: 0, r: 0, g: 0, b: 0 });
        bk.n += 1; bk.r += r; bk.g += g; bk.b += b;
      }
      const cols = Object.values(buckets).sort((x, y) => y.n - x.n).map((x) => [x.r / x.n, x.g / x.n, x.b / x.n]);
      if (!cols.length) return reject(new Error("No colours found in logo"));
      let primary = [...cols.slice(0, 4)].sort((x, y) => lum(x) - lum(y))[0];
      if (lum(primary) > 120) primary = primary.map((v) => v * (110 / lum(primary)));
      const accent = cols.find((x) => dist(x, primary) > 90 && lum(x) > 90) || [245, 179, 43];
      resolve({ primary: hex(...primary), secondary: hex(...accent) });
    } catch (e) { reject(e); }
  };
  img.onerror = () => reject(new Error("Could not load logo"));
  img.src = src;
});
